import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { setLanguage } from '../../language/actions'
import { getCustomerLanguage } from '../../actions/common'

// Elements
import Text from '../../shared/elements/text'
import Button from '../../shared/elements/button'
import Check from '../../shared/elements/check'
import Col from '../../shared/elements/col'
import Panel from '../../shared/elements/panel'
import PanelHeader from '../../shared/elements/panelHeader'
import Divider from '../../shared/elements/divider'

// Components
import PrivacyPolicy from '../../shared/components/PrivacyPolicy'

// Utils
import { translation } from '../../utils/helpers'

// Auth wrapper
import Auth from '../Auth'
import store from '../../store'
import { checkActionToken, submitActionToken } from '../../actions/auth'

// import styles
import './activate.scss'
import CloseButton from '../../shared/elements/closeButton'
import Header from '../../shared/components/Header'

class Activate extends Component {

  constructor (props) {
    super(props)
    this.onSubmit = this.onSubmit.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.validateToken = this.validateToken.bind(this)

    this.state = {
      ActivationCode: '',
      Name: '',
      Initials: '',
      UserName: '',
      Password: '',
      ConfirmPassword: '',
      Phone: '',
      Email: '',
      lockedActivationCode: false,
      Accept: false,
      DefaultLanguage: '',
      AsDefaultLanguage: false
    }
  }

  componentDidMount () {
    if (this.props.routeParams.activationCode !== undefined && this.props.routeParams.activationCode !== '') {
      this.setState({
        ...this.state,
        lockedActivationCode: true,
        ActivationCode: this.props.routeParams.activationCode
      }, () => {
        this.validateToken()
      })
    }
  }

  getDefautlLange () {
    let { AsDefaultLanguage, DefaultLanguage } = this.state
    if (!AsDefaultLanguage) {
      // get user language from lacalstorage and if this is undefined get the language from the result
      if (typeof window.localStorage.user_language !== 'undefined') {
        store.dispatch(setLanguage(window.localStorage.user_language))
        this.setState({AsDefaultLanguage: true})
      } else {
        if (!AsDefaultLanguage && DefaultLanguage) {
          store.dispatch(setLanguage(DefaultLanguage))
          this.setState({AsDefaultLanguage: true})
        } else {
          store.dispatch(setLanguage('English'))
        }
      }
    }
  }

  onSubmit (e) {
    e.preventDefault()

    let data = {
      ActivationCode: this.state.ActivationCode,
      Name: this.state.Name,
      Initials: this.state.Initials,
      UserName: this.state.UserName,
      Password: this.state.Password,
      ConfirmPassword: this.state.ConfirmPassword,
      Phone: this.state.Phone,
      Email: this.state.Email
    }
    this.props.submitActionToken(data).then((res) => {
      window.location.href = window.location.origin + '/login'
    }, (err) => {
      if (err.response.data !== undefined && err.response.data.length > 0) {
        err.response.data.map((error) => {
          window.toastr.error(translation(error.DictionaryKey))
        })
      }
    })
  }

  onChange (e) {
    let value = e.target.value
    if (e.target.type === 'checkbox') value = e.target.checked
    this.setState({
      [e.target.name]: value
    })
  }
  onBlur (e) {
    e.preventDefault()
    this.validateToken()
  }

  validateToken () {
    let data = {
      ActivationCode: this.state.ActivationCode
    }
    this.props.checkActionToken(data).then((res) => {
      this.setState({
        ...this.state,
        ActivationCode: res.data.ActivationCode,
        Name: res.data.Name,
        Email: res.data.Email,
        DefaultLanguage: res.data.DefaultLanguage
      }, () => {
        this.getDefautlLange()
      })
    }, (err) => {
      if (err.response.data.Errors !== undefined && err.response.data.Errors.length > 0) {
        err.response.data.Errors.map((error) => {
          window.toastr.error(translation(error.DictionaryKey))
        })
      }
    })
  }

  renderHelpTexts () {
    return (
      <ol className='helpTexts'>
        <li>{translation('16400')}</li>
        <li>{translation('16401')}</li>
        <li>{translation('16402')}</li>
        <li>{translation('16403')}</li>
        <li>{translation('16404')}</li>
        <li>{translation('16405')}</li>
        <li>{translation('16406')}</li>
        <li>{translation('16407')}</li>
      </ol>
    )
  }

  render () {
    const { Name, Email, ActivationCode, Accept } = this.state

    const goBack = (router, t) => {
      return (
        <div>
          <CloseButton spacing={0} ariaLabel={t('394')} onClick={() => router.goBack()} />
        </div>
      )
    }

    // Auth props before: showBack headerButtonsGoBack={goBack}
    return (
      <div className='activation__screen'>
        <Auth router={this.props.router} >
          <Header showBack headerButtonsGoBack={goBack.bind(this, this.props.router, translation)} />
          <div className='activation__layout'>
            <Panel>
              <h3 className='title'>{translation('16370')}</h3>
              <div className='activation__content'>
                <Col id='left-col'>
                  <PanelHeader text={16357} />
                  <div className='activation__content--left'>
                    <form onSubmit={this.onSubmit}>
                      <Text labelText={'1. ' + translation(16354)} helpText={16400} name='ActivationCode' required value={ActivationCode || ''} disabled={this.state.lockedActivationCode} onBlur={this.onBlur} onChange={this.onChange} />
                      <Text labelText={'2. ' + translation(30)} helpText={16401} name='Name' required value={Name || ''} onChange={this.onChange} />
                      <Text labelText={'3. ' + translation(1815)} helpText={16402} name='Initials' onChange={this.onChange} />
                      <Text labelText={'4. ' + translation(1)} helpText={16403} name='UserName' required onChange={this.onChange} />
                      <Text labelText={'5. ' + translation(2)} helpText={16404} name='Password' isPassword onChange={this.onChange} />
                      <Text labelText={'6. ' + translation(14883)} helpText={16405} name='ConfirmPassword' isPassword onChange={this.onChange} />
                      <Text labelText={'7. ' + translation(38)} helpText={16406} name='Phone' onChange={this.onChange} />
                      <Text labelText={'8. ' + translation(1052)} helpText={16407} name='Email' required value={Email || ''} onChange={this.onChange} />
                      <Divider />
                      <Check labelText={translation(16385)} name='Accept' id='accept' onChange={this.onChange} checked={Accept} required />
                      <div className='accept-text'>{translation(16386)}</div>
                      <div className='accept-text'>{translation(16387)}</div>
                      <Divider noLine />
                      <PrivacyPolicy text={translation(16655)} />
                      <Button labelText={16356} />
                    </form>
                  </div>
                </Col>
                <Col id='right-col'>
                  <PanelHeader text={16358} />
                  <div className='activation__content--right'>
                    {this.renderHelpTexts()}
                  </div>
                </Col>
              </div>
            </Panel>
          </div>
        </Auth>
      </div>
    )
  }
}

Activate.propTypes = {
  auth: PropTypes.object.isRequired
}

Activate.contextTypes = {
  router: React.PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    common: state.common
  }
}

export default connect(mapStateToProps, {
  getCustomerLanguage,
  setLanguage,
  checkActionToken,
  submitActionToken
})(Activate)



// WEBPACK FOOTER //
// ./src/app/pages/Activate/index.js